import { gql, useQuery } from '@apollo/client';
import { useId } from 'react';

import Dropdown, { DropdownProps } from './Dropdown';

interface IOption {
  value: number;
  label: string;
}

interface Props extends Omit<DropdownProps<IOption>, 'id' | 'options'> {
  id?: string;
  defaultOption?: IOption | number;
  value?: IOption | number;
  tracksTime?: boolean;
  joinedBeforeDate?: string;
}

const PEOPLELIST = gql`
  query UIKITPeopleDropdown($tracksTime: Boolean, $joinedBeforeDate: Date) {
    peopleV2(tracksTime: $tracksTime, joinedBeforeDate: $joinedBeforeDate) {
      id
      nameFirst
      nameLast
    }
  }
`;

function DropdownPeople(props: Props) {
  const id = props.id || useId();

  const { data } = useQuery(PEOPLELIST, {
    variables: {
      tracksTime: props.tracksTime || null,
      joinedBeforeDate: props.joinedBeforeDate || null,
    },
  });

  let options: Array<IOption> = [];

  if (data && data.peopleV2) {
    options = data.peopleV2.map((item) => ({
      value: item.id,
      label: `${item.nameFirst} ${item.nameLast}`,
    }));
    options.sort((a, b) => a.label.localeCompare(b.label));
  }

  return <Dropdown {...props} options={options} id={id} />;
}

export default DropdownPeople;
